export const iconFromType = (type, contextDataString) => {
  switch (type) {
    case 'message': {
      const contextData = JSON.parse(contextDataString);
      switch (contextData.bucket) {
        case 'issues':
          return 'error';
        case 'enquiries':
          return 'person_add';
        case 'inbox':
        default:
          return 'email';
      }
    }
    case 'ast_tenant_signed':
    case 'ast_all_signed':
      return 'edit';
    case 'outstanding_reference_request':
      return 'face';
    default:
      return 'notifications';
  }
}

export const routeFromType = (type, contextDataString) => {
  const contextData = JSON.parse(contextDataString);
  switch (type) {
    case 'message': {
      if (!(contextData.bucket && contextData.threadId)) {
        buildError(type, ['bucket', 'threadId']);
        return null;
      }
      return `/dashboard/messages/${contextData.bucket}/${contextData.threadId}`;
    }
    case 'ast_tenant_signed':
    case 'ast_all_signed': {
      if (!contextData.hash) {
        buildError(type, ['hash']);
        return null;
      }
      return `/properties/tenancy-agreements/view/${contextData.hash}`;
    }
    case 'outstanding_reference_request': {
      if (!contextData.hash || !contextData.type) {
        buildError(type, ['hash', 'type']);
        return null;
      }
      return `/properties/outstandingreferences/${contextData.hash}/${contextData.type}`;
    }
  }
}

const buildError = (type, expected) => {
  const err = new Error(`contextData shape for ${type} is incorrect. Expected { ${expected} }`);
  console.error(err);
  return err;
};


// WEBPACK FOOTER //
// ./src/helpers/notificationHelpers.js